import { html } from 'lit';
import { Home } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-home')
export class PdsIconHome extends PdsIcon {
  @state()
  icon = Home;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
